import React from "react";
import { Price } from "../main/motorcycles/MotorcycleView";
import Part, { PartProps } from "./Part";
import { connect } from "react-redux";
import {
	mapStateToProps,
	StateManagementProps,
	mapDispatchToProps
} from "../../utils/addReduxProps";
import { RouteComponentProps } from "react-router-dom";
import "./parts.scss";
import { sortAscendingByProperty } from "../../utils/helpers";
import { FullImage } from "../configuration/ConfigurationView";
import { WithNamespaces, withNamespaces } from "react-i18next";
import addPart from '../../redux/async-actions/addPart';
import removePartAsync from '../../redux/async-actions/removePart';
import store from '../../redux/store';
import CategoryName from '../shared/CategoryName';
import { Subscription } from "rxjs";
import { TransitionState } from "../../enums/transitionStates";
import { TranstitonStateValue } from '../../App';
import { distinctUntilChanged, filter } from "rxjs/operators";

export interface Part {
	PartId: string;
	Name: string;
	Price: Price;
	Racing: boolean;
	Description: html;
	Images: PartImages;
	CategoryName: string;
	ApprovalInfo: string;
	CanBeRendered: boolean;
}


// final don't touch
export interface TogglePartResponse {
	Price: Price;
	PartIds: string[];
	FullImages: FullImage[];
}

export interface Rule {
	RuleType: number;
	Part: Part;
}

export interface PartImages {
	Main: url;
	Other: url[];
}

type html = string;
type url = string;


export enum PartAction {
	Apply = "Apply",
	Remove = "Remove"
}

export type PartListAllProps =
	RouteComponentProps<{ categoryId: string }> &
	StateManagementProps &
	WithNamespaces;

export interface PartListState { }

export class PartList extends React.Component<PartListAllProps, PartListState> {
	sub: Subscription | undefined = undefined;
	constructor(props: PartListAllProps) {
		super(props);
		this.togglePart = this.togglePart.bind(this);
		this.addPart = this.addPart.bind(this);
		this.removePart = this.removePart.bind(this);
		this.showDialog = this.showDialog.bind(this);
	}

	togglePart(part: Part) {
		this.props.appliedParts.includes(part)
			? this.removePart(part)
			: this.addPart(part);
	}

	addPart(part: Part) {
		store.dispatch(addPart(part.PartId) as any);

	}
	removePart(part: Part) {
		store.dispatch(removePartAsync(part.PartId) as any);
	}

	showDialog(part: Part) {
		this.props.selectPart(part);
		this.props.togglePartDetail(true);
	}

	componentDidMount() {
		if (this.props.location.hash) {
			this.sub = TranstitonStateValue.pipe(
				distinctUntilChanged(),
				filter((item: TransitionState) => item === TransitionState.Exit),
			).subscribe(() => {
				setTimeout(() => {
					// @todo find better solution (investigate why refs not working ok)
					const el = document.getElementById(this.props.location.hash.substring(1))
					if (el) {
						el.scrollIntoView();
					}
				});
			}
			);
		}
	}

	componentWillUnmount() {
		this.sub && this.sub.unsubscribe();
	}

	render() {
		const {
			parts,
			selectedPart,
			appliedParts,
			categories,
			match: {
				params: { categoryId },
			},
			location: {
				hash,
			}
		} = this.props;
		const categoryName = categories[+categoryId];
		const categoryParts = parts.filter(
			(part: Part) => part.CategoryName === categoryName
		);
		if (!categoryParts) {
			return null;
		}
		return (
			<section id="select-parts">
				<div id="category-headline-wrapper">
					<h2 className="uppercase category-heading"><CategoryName text={categoryName} /></h2>
				</div>
				<div id="parts-wrapper">
					{categoryParts
						.sort(sortAscendingByProperty<Pick<Part, 'Name'>>('Name'))
						.map((part: Part, index: number) => {
							let props: PartProps = {
								isIncluded: appliedParts.includes(part),
								togglePart: this.togglePart,
								part: part,
								selectedFromSummary: false,
								showDialog: this.showDialog,
								fade: "PartId" in selectedPart && !Object.is(part, selectedPart)
							};
							if (hash && part.PartId === hash.substring(1)) {
								props = {
									...props,
									selectedFromSummary: true,
								}
							}

							return <Part key={index} {...props} />;
						})}
				</div>
			</section>
		);
	}
}

export default withNamespaces()(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(PartList)
);
